/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteBlockListByCompanyIdsRequestBody
 */
export interface DeleteBlockListByCompanyIdsRequestBody {
    /**
     * 除外リストから削除する選択した企業IDのリスト
     * @type {Array<number>}
     * @memberof DeleteBlockListByCompanyIdsRequestBody
     */
    companyIds: Array<number>;
}

export function DeleteBlockListByCompanyIdsRequestBodyFromJSON(json: any): DeleteBlockListByCompanyIdsRequestBody {
    return DeleteBlockListByCompanyIdsRequestBodyFromJSONTyped(json, false);
}

export function DeleteBlockListByCompanyIdsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteBlockListByCompanyIdsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyIds': json['company_ids'],
    };
}

export function DeleteBlockListByCompanyIdsRequestBodyToJSON(value?: DeleteBlockListByCompanyIdsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_ids': value.companyIds,
    };
}

